import { Heart } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Rsvp({ datos, seccion, acciones }) {
  const rsvp = datos.rsvp || {};

  return (
    <section className="km-seccion km-rsvp" aria-label={seccion.titulo}>
      <div className="km-seccion-interior">
        <EncabezadoSeccion p="km" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="km-titulo-rsvp" />
        <Reveal delay={0.1}>
          {rsvp.mensaje && <p className="km-rsvp-mensaje">{rsvp.mensaje}</p>}
          {rsvp.fechaLimite && <p className="km-rsvp-limite">{rsvp.fechaLimite}</p>}
          <button
            type="button"
            className="km-boton km-boton--claro"
            onClick={() => acciones?.onConfirmarAsistencia?.()}
            data-testid="km-boton-rsvp"
          >
            <Heart strokeWidth={2} />
            {rsvp.textoBoton || "Confirmar asistencia"}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
